import React from "react";
import PropTypes from "prop-types";

import { MicrodataContext } from "config/contexts";
import { STREAM_TYPE, INCLUSION_EDGE_TYPE } from "config/constants";
import StreamAd from "stream/containers/StreamAd";
import NewsletterPromoCard from "cards/containers/NewsletterPromoCard";

export default class StreamItem extends React.Component {
  constructor(props) {
    super(props);
    this.domNode = null;
  }

  componentDidMount() {
    this.props.measure();

    if (this.props.edge.__typename == INCLUSION_EDGE_TYPE.CONTENT) {
      this.props.registerStreamItemNode(
        this.domNode,
        this.props.edge,
        this.props.index
      );
    }
  }

  componentWillUnmount() {
    if (this.props.edge.__typename == INCLUSION_EDGE_TYPE.CONTENT) {
      this.props.unregisterStreamItemNode(this.domNode);
    }
  }

  renderItem() {
    const ContentComponent = this.props.contentComponent;

    switch (this.props.edge.__typename) {
      case INCLUSION_EDGE_TYPE.CONTENT:
        return (
          <MicrodataContext.Provider
            value={
              !this.props.index ||
              this.props.streamType !== STREAM_TYPE.PERMALINK
            }
          >
            <ContentComponent
              story={this.props.edge.node}
              isFeatured={this.props.edge.isFeatured}
              index={this.props.index}
              showSaveTag={this.props.showSaveTag}
            />
          </MicrodataContext.Provider>
        );

      case INCLUSION_EDGE_TYPE.AD:
        return <StreamAd node={this.props.edge.node} />;

      case INCLUSION_EDGE_TYPE.NEWSLETTER_PROMO:
        return <NewsletterPromoCard />;

      default:
        return null;
    }
  }

  render() {
    return (
      <div
        ref={el => {
          this.props.measureRef(el);
          this.domNode = el;
        }}
      >
        {this.renderItem()}
      </div>
    );
  }
}

StreamItem.propTypes = {
  edge: PropTypes.shape({
    node: PropTypes.shape({
      __typename: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
  measure: PropTypes.func.isRequired,
  measureRef: PropTypes.func.isRequired,
  index: PropTypes.number,
  streamType: PropTypes.oneOf(Object.values(STREAM_TYPE)),
  contentComponent: PropTypes.func,
  registerStreamItemNode: PropTypes.func,
  unregisterStreamItemNode: PropTypes.func,
  showSaveTag: PropTypes.bool,
};
